import { LabelStateV1 } from './annotation.types';

export class ModalClassManager {
  static getClassColor(ctx: any, label: string): string {
    return ctx.classColors[label] ?? '#777777';
  }

  static updateImageClassFieldOptions(ctx: any): void {
    if (!ctx.hasImageStrategy) return;

    // Validate the live model selection against the current class list.
    if ((ctx.model as any)['Class'] && !ctx.imageClasses.includes((ctx.model as any)['Class'])) {
      delete (ctx.model as any)['Class'];
      ctx.saveButtondisabled = true;
    }

    const currentItem = ctx.dataArray?.[ctx.currentIndex];
    const persistedValue = ctx.getPersistedFormFieldValue(currentItem, 'Class');
    if (
      persistedValue !== undefined &&
      persistedValue !== null &&
      !ctx.imageClasses.includes(String(persistedValue))
    ) {
      // Sanitize persisted row value so stale class names do not reappear.
      if ((currentItem as any)?.['Class'] && typeof (currentItem as any)['Class'] === 'object') {
        const { value, ...rest } = (currentItem as any)['Class'];
        void value;
        (currentItem as any)['Class'] = rest;
      }
      ctx.saveButtondisabled = true;
    }
  }

  static syncClassesIntoExistingLabelStates(ctx: any, labelStateKey: string): void {
    if (!ctx.dataArray) {
      return;
    }

    const imageClasses = [...ctx.imageClasses];
    const annotationClasses = [...ctx.annotationClasses];
    const classColors = { ...ctx.classColors };

    for (const item of ctx.dataArray) {
      const state = item?.[labelStateKey] as LabelStateV1 | undefined;
      if (!state?.classes) {
        continue;
      }

      state.classes.imageClasses = imageClasses;
      state.classes.annotationClasses = annotationClasses;
      state.classes.rectClasses = [...ctx.rectClasses];
      state.classes.polygonBrushClasses = [...ctx.polygonBrushClasses];
      // Merge keeps item-specific colors while applying latest global updates.
      state.classes.classColors = {
        ...state.classes.classColors,
        ...classColors,
      };
      state.classes.allowUserToEditClasses = ctx.allowUserToEditClasses;
    }
  }
}
